import { db } from './firebase';
import { collection, addDoc, query, where, onSnapshot, getDoc, doc, deleteDoc, updateDoc } from 'firebase/firestore';

// Referencia a la colección de grupos y cuentas en Firebase
const groupsCollection = collection(db, 'groups');
const accountsCollection = collection(db, 'accounts');

// Función para crear un grupo en Firebase
export const createGroup = async (group) => {
    try {
        const docRef = await addDoc(groupsCollection, group);
        return docRef.id;
    } catch (error) {
        console.error('Error creando el grupo:', error);
        throw error;
    }
};


export const updateGroup = async (group, updatedGroup) => {
    if (!group || !group.id) {
        throw new Error('El grupo proporcionado no es válido o no tiene un ID.');
    }

    if (!updatedGroup || typeof updatedGroup !== 'object') {
        throw new Error('Los datos actualizados proporcionados no son válidos.');
    }

    const groupId = group.id;
    const mergedData = {
        ...group,
        ...updatedGroup, // Combinar los datos existentes con los nuevos
    };

    // console.log('Datos combinados enviados a Firestore:', mergedData);

    try {
        const groupDocRef = doc(db, 'groups', groupId);
        await updateDoc(groupDocRef, mergedData); // Usar los datos combinados
    } catch (error) {
        console.error('Error al actualizar el grupo:', error);
        throw error;
    }
};

export const deleteGroup = async (group) => {
    try {
        const groupDocRef = doc(db, 'groups', group.id);
        await deleteDoc(groupDocRef);
    } catch (error) {
        console.error('Error eliminando el grupo:', error);
        throw error;
    }
};

// Función para obtener grupos en tiempo real y consultar las cuentas asociadas
export const onGroupsSnapshot = (userId, callback) => {
    const q = query(groupsCollection, where('collaboratorsUid', 'array-contains', userId));

    const handleSnapshot = async (snapshot) => {
        const groups = await Promise.all(
            snapshot.docs.map(async (docSnapshot) => {
                const groupData = { id: docSnapshot.id, ...docSnapshot.data() };

                // Consultar las cuentas asociadas al grupo
                if (groupData.accounts && groupData.accounts.length > 0) {
                    const accountDocs = await Promise.all(
                        groupData.accounts.map(async (accountId) => {
                            const accountDocRef = doc(accountsCollection, accountId); // Crear referencia al documento
                            const accountDoc = await getDoc(accountDocRef); // Obtener el documento
                            const accountData = accountDoc.data();

                            // Validar que accountData.collaborators sea un array antes de usar .some
                            if (Array.isArray(accountData?.collaborators) && accountData.collaborators.some(collab => collab.uid === userId)) {
                                return { id: accountId, ...accountData };
                            }
                            return null; // Excluir cuentas donde el usuario no es colaborador
                        })
                    );

                    // Filtrar cuentas nulas (no colaborador)
                    groupData.children = accountDocs.filter(account => account !== null);
                } else {
                    groupData.children = []; // Si no hay cuentas, agregar un array vacío
                }

                return groupData;
            })
        );

        return groups;
    };

    const unsubscribeGroups = onSnapshot(
        q,
        async (snapshot) => {
            const groupsWithAccounts = await handleSnapshot(snapshot);
            callback(groupsWithAccounts);
        },
        (error) => {
            console.error('Error fetching groups snapshot: ', error);
            callback([]);
        }
    );

    return () => {
        unsubscribeGroups();
    };
};